import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Check, Sparkles } from "lucide-react";
import MembershipCardPreview from "@/components/MembershipCardPreview";

const perks = [
  "Unlimited free doctor consultations for 365 days",
  "Flat 10% off on blood tests, X-Ray, sonography",
  "10% off CT scan and MRI at all centres",
  "Card delivered instantly on WhatsApp & SMS",
  "Unique alphanumeric membership number",
  "Valid across 18+ 1Rupee Clinics",
];

export const PricingCTA = () => {
  return (
    <section className="relative py-20 sm:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-soft" />
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 h-[420px] w-[820px] bg-aqua-glow blur-3xl opacity-80" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="text-xs font-semibold uppercase tracking-[0.18em] text-primary mb-3">
              One-time fee
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-foreground">
              Pay <span className="text-gradient-aqua">₹100</span>. Save thousands.
            </h2>
            <p className="mt-4 text-muted-foreground text-base sm:text-lg max-w-xl">
              No subscriptions. No renewals to remember during the year. One transparent
              payment unlocks every benefit for 12 months.
            </p>

            <ul className="mt-7 space-y-3 max-w-md">
              {perks.map((p) => (
                <li key={p} className="flex items-start gap-3 text-sm text-foreground">
                  <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-success/15 text-success mt-0.5">
                    <Check className="h-3 w-3" strokeWidth={3} />
                  </span>
                  {p}
                </li>
              ))}
            </ul>

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <Link to="/generate">
                <Button size="lg" className="h-12 px-6 bg-gradient-primary text-primary-foreground shadow-elegant rounded-xl">
                  <Sparkles className="h-4 w-4" /> Generate my card now
                </Button>
              </Link>
              <div className="text-xs text-muted-foreground">
                Secure checkout via <span className="font-semibold text-foreground">Razorpay</span>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="absolute inset-0 -z-10 rounded-3xl bg-gradient-primary opacity-20 blur-3xl" />
            <MembershipCardPreview
              name="Riya Mehta"
              mobile="9123456789"
              membershipNumber="XXXXXXXX"
              issued="24 Jan 2025"
              expires="24 Jan 2026"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingCTA;
